export const TransactionApplication = {
  ALLPAID: "APD",
  ALLPAID_VT: "APD VT",
  CYG_VT: "CYG VT",
};

// Written directly to the GPS database by GPN (see TransactionSourceLabel in
// apps/gpn) and ws-soap (TransactionTranslator). These are not AWS transactions,
// so they are intentionally left out of showsUuid below.
export const DirectTransactionApplication = {
  GPN: "GPN",
  CYG: "CYG",
  CYG_SIMPLE_POST: "CYG SimpP",
  CYG_SECURE_POST: "CYG SecP",
  AGENT_UI: "CYG AUI",
  GPN_REGISTERED_USER: "GPN RU",
  WS_SOAP: "WS SOAP",
};

// GPS rows written before the APD labels: "Allpaid", and briefly "AllPaid VT".
const LEGACY_UUID_APPLICATIONS = ["allpaid", "allpaid vt"];

export const showsUuid = (application) => {
  if (typeof application !== "string") {
    return false;
  }
  const value = application.toLowerCase();
  return (
    LEGACY_UUID_APPLICATIONS.includes(value) ||
    Object.values(TransactionApplication).some(
      (stored) => stored.toLowerCase() === value
    )
  );
};
